import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/faturamento";

/**
 * Classe de gerenciamento de chamadas da API de faturamento
 *
 * @class
 */
export default class FaturamentoApi {
  /**
   * Instância da dependência da API (ofetch)
   */
  private api;

  /**
   * Cria uma nova instância da classe FaturamentoApi.
   * @constructor
   * @param api - Instância da dependência da API (ofetch).
   */
  constructor(api: $Fetch) {
    this.api = api;
  }

  /**
   * Atualiza lotes
   * @param listaCodigos - Lista de códigos de lotes
   * @param loteFaturaDto - Dados do lote de fatura
   * @returns Resposta da atualização de lotes
   */
  async atualizarLotes(listaCodigos: string, loteFaturaDto: any) {
    try {
      const resp = await this.api(`${controller}/atualizarlotes/${listaCodigos}`, {
        method: "PUT",
        body: loteFaturaDto,
      });
      return resp;
    } catch (error) {
      console.error("Erro ao atualizar lotes:", error);
      throw error;
    }
  }

  /**
   * Calcula execução
   * @returns Resultado do cálculo da execução
   */
  async calcularExecucao() {
    try {
      const resp = await this.api(`${controller}/calacularexecucao`, {
        method: "GET",
      });
      return resp;
    } catch (error) {
      console.error("Erro ao calcular execução:", error);
      throw error;
    }
  }

  /**
   * Calcula despesa de execução
   * @returns Resultado do cálculo de despesa
   */
  async calcularDespesaExecucao() {
    try {
      const resp = await this.api(`${controller}/calculardespesa`, {
        method: "GET",
      });
      return resp;
    } catch (error) {
      console.error("Erro ao calcular despesa de execução:", error);
      throw error;
    }
  }

  /**
   * Exclui lote
   * @param codLoteFatura - Código do lote de fatura
   * @param listaCodigos - Lista de códigos
   * @param email - Email do usuário
   * @param senha - Senha do usuário
   * @param permitido - Permissão para exclusão
   * @returns Resultado da exclusão do lote
   */
  async excluirLote(codLoteFatura: number, listaCodigos: string, email: string, senha: string, permitido: boolean) {
    try {
      const resp = await this.api(`${controller}/excluirlote/${codLoteFatura}/${listaCodigos}/${email}/${senha}/${permitido}`, {
        method: "DELETE",
      });
      return resp;
    } catch (error) {
      console.error("Erro ao excluir lote:", error);
      throw error;
    }
  }

  /**
   * Gera lote
   * @param loteFaturaDto - Dados do lote de fatura
   * @returns Resultado da geração de lote
   */
  async gerarLote(loteFaturaDto: any) {
    try {
      const resp = await this.api(`${controller}/gerarlote`, {
        method: "POST",
        body: loteFaturaDto,
      });
      return resp;
    } catch (error) {
      console.error("Erro ao gerar lote:", error);
      throw error;
    }
  }

  /**
   * Lista guias
   * @param params - Parâmetros de filtro das guias
   * @returns Lista de guias filtradas
   */
  async listarGuias(params: FiltroGuias) {
    try {
      const resp = await this.api(`${controller}/listarguias`, {
        method: "GET",
        params,
      });
      return resp;
    } catch (error) {
      console.error("Erro ao listar guias:", error);
      throw error;
    }
  }
}
